import { render, staticRenderFns } from "./RetentionMgmt.vue?vue&type=template&id=3c338ba2"
import script from "./RetentionMgmt.vue?vue&type=script&lang=js"
export * from "./RetentionMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports